:host {
  display: block;
  font-family: 'Work Sans', sans-serif;
}

.tree-node-content {
  cursor: pointer;
  height: 2rem;
  padding-inline-end: calc(1rem - 0.125rem);
  box-sizing: border-box;
  outline: none;
  display: flex;
  align-items: center;
  position: relative;
  border: 0.125rem solid transparent;

  .tree-node-label {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0.5rem;
    color: var(--text-secondary, $secondary);
    font-family: 'Work Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.01rem;
    line-height: 1.125rem;
  }

  .expand-icon {
    transform: rotate(0deg);
    transition: all 0.11s cubic-bezier(0.2, 0, 0.38, 0.9);
  }

  .expand-icon.expanded {
    transform: rotate(+90deg);
  }

  .icon-space {
    width: var(--spacing-05, 1rem);
  }

  .icon {
    padding-inline-start: 0.5rem;
  }
}

.node-slot {
  display: none;
}

.node-slot.expanded {
  display: block;
}

.tree-node-content {
  &:hover {
    background: var(--layer-hover, #f2f4f7);

    &.selected {
      background: var(--layer-selected-hover, $orange-100);
    }
  }

  &.has-focus:not(.selected) {
    color: var(--text-primary, $secondary);
    border-color: var(--color-primary, $primary);

    .slot-end {
      color: var(--icon-01, $dark);
    }
  }

  &.selected {
    background: var(--layer-selected, $orange-100);
    font-weight: var(--font-weight-semi-bold, 600);
    border-left: 0.125rem solid transparent;
  }

  &.selected::before {
    content: ' ';
    display: block;
    height: calc(100% + 0.25rem);
    border-left: 0.25rem solid var(--color-primary, $primary) !important;
    position: absolute;
    top: -0.125rem;
    left: -0.125rem;
  }
}

.link {
  color: inherit !important;
  text-decoration: none !important;
}

.tree-node-content.disabled {
  cursor: not-allowed;
  color: var(--text-disabled, $neutral-200) !important;
  &:hover,
  &.has-focus:not(.selected) {
    color: var(--text-disabled, $neutral-200) !important;
  }

  &.selected {
    color: var(--text-disabled, $neutral-200) !important;
  }
}

.size {
  width: 1rem;
  height: 1rem;
}

.mr-2 {
  margin-right: 0.2rem;
}
